// extracted by mini-css-extract-plugin
module.exports = {"noSelect":"_2oe49s6G1-y1E0YATcgg7C"};